module.exports = __webpack_public_path__ + "static/media/logo-name.164740db.svg";